import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

import type { AuthSlice } from '@/stores/auth';
import { ApiClientProvider } from '@/providers/ApiClientProvider';
import { SandboxNoticeBar } from '@/components/layout/sandbox-notice-bar';
import Force2FAModal from '@/features/account-settings/profile/components/force-2fa-modal';

export const rootRoute = createRootRouteWithContext<{
  authStore: AuthSlice;
  queryClient: QueryClient;
}>()({
  component: RootComponent,
});

// eslint-disable-next-line react-refresh/only-export-components
function RootComponent() {
  return (
    <ApiClientProvider>
      <SandboxNoticeBar />
      <Force2FAModal />
      <Outlet />
    </ApiClientProvider>
  );
}
